import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminGuard from "@/components/AdminGuard";
import Dashboard from "@/pages/Dashboard";
import MagazineEditor from "@/pages/MagazineEditor";
import MagazineView from "@/pages/MagazineView";
import SubscribersPage from "@/pages/SubscribersPage";

function App() {
  return (
    <div className="App min-h-screen bg-[#FDFBF7]">
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/view/:id" element={<MagazineView />} />

          {/* Admin auth */}
          <Route path="/admin" element={<AdminLogin />} />

          {/* Protected admin routes */}
          <Route path="/admin/dashboard" element={<AdminGuard><Dashboard /></AdminGuard>} />
          <Route path="/admin/editor/:id" element={<AdminGuard><MagazineEditor /></AdminGuard>} />
          <Route path="/admin/subscribers" element={<AdminGuard><SubscribersPage /></AdminGuard>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
